var scrollerInit = function () {
    var scrollAutoLinks = $('[data-auto-scroll]');

    scrollAutoLinks.on('click', function () {

        $(this).
        toggleClass("is-scrolled");

        var isLinkScrolled = $(this).hasClass("is-scrolled");

        if (isLinkScrolled) {
            var devicewidth = $(window).width();
            var mobileheaderHeight = $('.m-header').outerHeight();
            var elementTopPosition = $(this).offset().top;

            var offset = devicewidth < 768 ? mobileheaderHeight
            : 0;

            $("html, body").animate({
                scrollTop: elementTopPosition - offset
            }, 500);
        }
    });
};